import { createContext } from 'react'

interface InterfaceContext {
  height: number
  setHeight: (height: number) => void
}

export default createContext({} as InterfaceContext)
